<div class="event-previews-list-modal">
  <div class="event-previews-list-modal__item" *ngFor="let item of items">
    <brt-event-mini-preview [data]="item"></brt-event-mini-preview>
  </div>
</div>
